var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M17 8.5C17 3.81223 13.1878 0 8.5 0C3.81223 0 0 3.81223 0 8.5C0 13.1878 3.81223 17 8.5 17H16.927L15.258 13.6438C16.3844 12.1663 17 10.3605 17 8.5ZM9.94099 13.6848H7.4831V11.9839H9.94099V13.6848ZM9.95467 9.60354V10.625H7.49678V9.52602C7.49678 8.60032 8.10327 7.77039 9.01073 7.45574C9.31626 7.35086 9.52146 7.08637 9.52146 6.79453C9.52146 6.40692 9.16121 6.08772 8.72344 6.08772C8.28568 6.08772 7.92543 6.40692 7.92543 6.79453V7.15478H5.46754V6.79453C5.46754 5.12554 6.92677 3.76663 8.72344 3.76663C10.5201 3.76663 11.9793 5.12554 11.9793 6.79453C11.9793 8.02119 11.1677 9.13385 9.95467 9.59898V9.60354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatQuestion);
export default __webpack_public_path__ + "static/media/chat-question.f1d42ea983ad71f1ec807fa1263899cf.svg";
export { ForwardRef as ReactComponent };